import { BASE_URL } from './../config';

async function fetchApi(endpoint, method = 'GET', body = null, needsAuth = false) {
  const headers = {
    'Content-Type': 'application/json'
  };

  if (needsAuth) {
    const token = localStorage.getItem('token');
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
  }

  const config = { method, headers };

  if (body) {
    config.body = JSON.stringify(body);
  }

  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, config);
    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'خطایی رخ داد.');
    }

    return { success: true, data };
  } catch (error) {
    return {
      success: false,
      message: error.message || 'خطا در ارتباط با سرور.'
    };
  }
}

export default fetchApi;